import React from "react";
import { Grid, MenuItem, TextField } from "@mui/material";
import { capitalizeFirstLetter, autoCapitalizeWords } from "../constants";

const QTDetailsTextFieldWithLabelSection = ({
  label,
  value,
  onChange,
  disabled,
  multiline,
  rows,
  type,
  editEnabled,
  select,
  dropdownValues,
  placeholder,
  helperText,
  capitalizeWords,
  noTextTransform = false,
}) => {
  const handleChange = capitalizeWords ? autoCapitalizeWords(onChange) : onChange;

  return (
    <Grid container alignItems={"center"} style={{ marginBottom: 24 }}>
      <span style={titleTextStyle}>{label}</span>
      <TextField
        variant="outlined"
        disabled={editEnabled ? false : disabled}
        placeholder={placeholder}
        // defaultValue={value && select ? capitalizeFirstLetter(value) : value}
        value={
          !editEnabled && select ? value && capitalizeFirstLetter(value) : value
        }
        onChange={handleChange}
        multiline={multiline}
        rows={rows}
        type={type}
        select={editEnabled && select ? select : false}
        helperText={helperText}
        sx={{
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#000000",
          },
        }}
        style={{
          width: "70%",
          textTransform: select && !noTextTransform ? "capitalize" : undefined,
          // color:
          //   value == "pending"
          //     ? "#E48900"
          //     : value == "approved"
          //     ? "#128D1F"
          //     : value == "denied"
          //     ? "#BA344C"
          //     : "#020303",
        }}
        InputProps={{
          sx: {
            ...textfieldSXStyles,
            height: multiline ? undefined : 40,
            backgroundColor: editEnabled ? "#D2D2D2" : "#FFFFFF",
            color:
              value == "pending"
                ? "#E48900"
                : value == "approved"
                ? "#128D1F"
                : value == "denied"
                ? "#BA344C"
                : "#020303",
          },
          style: { textTransform: select && !noTextTransform ? "capitalize" : undefined },
        }}
      >
        {editEnabled && select
          ? dropdownValues &&
            dropdownValues.map((item, index) => (
              <MenuItem
                key={`${item}-${index}`}
                style={{
                  textTransform: noTextTransform ? undefined : "capitalize",
                  color:
                    item == "pending"
                      ? "#E48900"
                      : item == "approved"
                      ? "#128D1F"
                      : item == "denied"
                      ? "#BA344C"
                      : "#020303",
                }}
                value={item}
              >
                {item}
              </MenuItem>
            ))
          : undefined}
      </TextField>
    </Grid>
  );
};

export default QTDetailsTextFieldWithLabelSection;

const titleTextStyle = {
  width: "25%",
  color: "#020303",
  fontSize: 14,
  fontWeight: 700,
  fontFamily: "Avenir Book, sans-serif",
};

const textfieldSXStyles = {
  height: 40,
  border: "none",
  borderColor: "#7676801F",
  color: "#515563",
  fontSize: 14,
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif",
  //   paddingLeft: 1,
};
